import { render, staticRenderFns } from "./RequestByTypePerDayInAMonthBarChart.vue?vue&type=template&id=1e52d3c4&scoped=true&"
import script from "./RequestByTypePerDayInAMonthBarChart.vue?vue&type=script&lang=js&"
export * from "./RequestByTypePerDayInAMonthBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e52d3c4",
  null
  
)

export default component.exports